import { linkResolver } from './linkResolver';

import { DocumentType } from '../constants/Enums';

export const getTagList = ({ lang, tag1 = null, tag2 = null, tag3 = null }) => {
  const tags = [
    {
      name: tag1?.document?.data?.tag_name || null,
      uid: linkResolver({
        lang,
        uid: tag1?.document?.uid || null,
        type: DocumentType.TAG,
      }),
    },
    {
      name: tag2?.document?.data?.tag_name || null,
      uid: linkResolver({
        lang,
        uid: tag2?.document?.uid || null,
        type: DocumentType.TAG,
      }),
    },
    {
      name: tag3?.document?.data?.tag_name || null,
      uid: linkResolver({
        lang,
        uid: tag3?.document?.uid || null,
        type: DocumentType.TAG,
      }),
    },
  ];

  return tags.filter(tag => tag?.name && tag?.uid);
};
